// Knowledge Base trusted-sender rule: the CLIENT MIRROR (Session AGJ).
//
// A read-only mirror of server/src/modules/knowledge/trustedSenders.ts, so the office Settings screen
// can refuse a typo with a plain-English message at the moment it is typed. Without it the address
// would be accepted, shown on the list as though saved, and then silently discarded by the hourly
// sweep -- a configuration that looks correct and ingests nothing.
//
// THE SERVER REMAINS THE AUTHORITY: it re-validates and re-normalises every list it stores, so a
// stale or bypassed mirror can never widen the allow-list. This file exists for the message, not the
// enforcement.
//
// Kept in step by server/src/modules/settings/settingsTrustedSenders.test.ts, which compares the
// pattern source and the cap against the server constants (the quotePricing client/server mirror
// pattern). It is a plain .ts module rather than constants on the page because the server-side parity
// test cannot import a .tsx file (the server tsconfig does not set --jsx).

// Must stay character-for-character identical to the server's TRUSTED_SENDER_ADDRESS_PATTERN; see
// that constant for WHY each excluded character matters (a brace or bracket does not just break its
// own sender, it corrupts the sweep's single Gmail query and stops every trusted sender at once).
export const TRUSTED_SENDER_PATTERN = /^[^\s<>(),;:"{}@]+@[^\s<>(),;:"{}@]+\.[a-z]{2,}$/;

export const KB_TRUSTED_SENDERS_MAX = 50;
